import React from 'react';
import T from 'prop-types';
import { Link } from 'react-router-dom';
import Icon from '../../../components/Icon/Icon';
import styles from './EditIcon.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const EditIcon = ({ color, editLink }) => (
  <Link
    to={editLink}
    className={cx('edit-button', 'hint--top')}
    data-hint="Edit"
  >
    <Icon color={color} type="pen" />
  </Link>
);

EditIcon.propTypes = {
  editLink: T.oneOfType([T.string, T.object]),
  color: T.string
};

export default React.memo(EditIcon);



// WEBPACK FOOTER //
// ./src/containers/RecoveryPlan/components/EditIcon.jsx